// extracted by mini-css-extract-plugin
module.exports = {"trash":"styles-module__trash___23EJT"};